// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-wrapper[data-v-4d264453] .v-input__append-inner{-ms-flex-item-align:center;align-self:center;margin:0!important}", ""]);
// Exports
module.exports = exports;
